"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLoyaltyBehavior = void 0;
const api_1 = require("../api");
const base_1 = require("./base");
/**
 * Third-party providers reached through the loyalty gateway (springbig, alpineiq…).
 * They expose a points balance but no enrollment or tier concept.
 */
class ExternalLoyaltyBehavior extends base_1.LoyaltyBehaviorBase {
    constructor(context) {
        super();
        this.context = context;
        this.capabilities = {
            usesProviderPoints: true,
            showsInternalLoyaltyData: false,
            supportsEnrollment: false,
            supportsPointsRetry: true,
            // Third-party points are redeemable, and sit alongside the platform display.
            contributesPointsToPayment: true,
            isSoleLoyaltyDisplay: false,
        };
    }
    loadCustomerLoyalty(customer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const points = yield (0, api_1.getExternalLoyaltyPoints)({
                    gatewayUrl: this.context.getGatewayUrl(),
                    merchantId: this.context.getMerchantId(),
                    customer,
                });
                return { status: 'enrolled', points, tier: null };
            }
            catch (error) {
                return { status: 'error', message: 'Failed to load loyalty points' };
            }
        });
    }
}
exports.ExternalLoyaltyBehavior = ExternalLoyaltyBehavior;
//# sourceMappingURL=external.js.map